import { render, staticRenderFns } from "./IndicadorUnico.vue?vue&type=template&id=c342248e&"
import script from "./IndicadorUnico.vue?vue&type=script&lang=js&"
export * from "./IndicadorUnico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports